export default {
    Home:{
        homeTit:'欢迎来到后台管理系统',
        leftMenu:'请从左侧菜单选择',
        governlogon:"管理员登录",
        logon:"登录",
        NOReLogin:"登陆已失效，需要重新登陆吗？",
        ReLogin:"重新登陆",
        NOLogin:'取消登陆',
        overtime:"请求超时，请稍后再试",
        networkError:"网络错误，请检查您的网络连接",
        noResponse:"服务器未响应，请稍后再试",
        CCKTiTle:"CCK统一门户"
    },
    Menu:{
        homePage:'首页',
        userManagement:'用户管理',
        userList:'用户列表',
        addAUser:'新增用户',
        clientManagement:'客户端管理',
        clientList:'客户端列表',
        addingAClient:'新增客户端',
        authorityManagement:'权限管理',
        administratorList:'管理员列表',
        addAnAdministrator:'新增管理员',
        work:"在线办公",
        staff:"员工APP",
        client:"客户APP",
        // settings:"系统设置",

    },
    Button:{
        inquire:'查询',
        changePassword:'修改密码',
        modifyInformation:'修改信息',
        forbidden:'禁用',
        recover:'恢复',
        previous:'上一页',
        nextPage:'下一页',
        cancel:'取消',
        submit:"提交",
        normal:'正常',
        unknownState:'未知状态',
        verify:'确认',
        save:'保存',
        reset:'重置',
        displayKey:'显示密钥',
        englishTemplate:"英文模板",
        vietnameseTemplates:"越南语模板",
        chineseTemplate:'中文模板',
        English:"英文",
        Chinese:'中文',
        Vietnamese:'越南语',
        VN:"越南",
        Thai:"泰国语",
        Copy:"复制",
        nameTube:'域名管理',
        phoneCode:'手机验证码',
        emailCode:'邮箱验证码',
        infoCode:'信息校验',
        no:'否',
        is:'是',
        LogOut:"退出登录",
        Email:'邮箱',
        Vcode:'验证码',
        OVcode:'获取验证码',
        OAOffice:'OA办公',
        download:"点击下载",
        sailSoft:"帆软"
    },
    Tips:{
        pleaseEnterQueryContent:"请输入查询内容",
        noDataAvailable:'暂无数据',
        warmReminder:'温馨提示',
        pleaseEnterPassword:'请输入密码',
        passwordLengthIsTooShort:'密码长度不能小于六位',
        passwordStatusError:"密码和确认密码不一致，请重新输入",
        pleaseConfirmPassword:'请确认密码',
        passwordChangedSuccessfully:'密码修改成功',
        mobilePhoneFormatError:'手机号格式不正确',
        enterUsername:'请输入用户名',
        userNameLengthLimit:"用户名长度在 3 到 20 个字符之间",
        enterMobileNumber:'请输入手机号',
        enterEmailAddress:'请输入邮箱地址',
        emailAddressError:'邮箱地址格式不正确',
        enterIdNumber:'请输入身份证号',
        idNumberError:'身份证号格式不正确',
        enterUserAddress:'请输入用户地址',
        userHasReEntered:'用户已经存在请重新输入',
        submitSuccessfully:"提交成功!",
        requestTimeout:"请求超时",
        TetxdisableUser1:'您确定要',
        TetxdisableUser2:'用户吗？',
        stateChange:"成功！",
        inputUserApp:'请输入用户所属app',
        userAppLengthLimit:'用户所属app长度在 6 到 8 个字符之间',
        inputuserID:'请输入用户ID',
        userIdLengthLimit:'用户ID长度在 5 到 10 个字符之间',
        enterUserPassword:'请输入用户密码',
        UserPasswordLengthLimit:'用户密码长度在 3 到 10 个字符之间',
        enterUserSource:'请输入用户来源',
        UserSourceLengthLimit:'用户来源长度在 3 到 10 个字符之间',
        enterUserRole:"请输入用户角色",
        saveComplete:'保存完成!',
        enterCustomerName:'请输入客户名称',
        CustomerNameLengthLimit:"客户名称不能小于2位",
        selectLoginTemplate:'请选择登录模板',
        pleaseSelectLoginTemplate:'您还没有选择登陆模板',
        selectLanguage:'请选择语言',
        noChoiceLanguage:'您还没有选择语言',
        submissionCompleted:"信息提交完成!",
        undeveloped:'暂未开发',
        copySuccess:"复制成功",
        nocopy:"复制失败请手动复制",
        pleaseSelect:"请选择",
        inputValidJSON:'请输入有效的JSON格式',
        inputSystem:'请输入对接系统ID',
        stytemLengthLimit:'对接系统ID长度在 5 到 8 个字符之间',
        InputSystemLogo:'请输入对接系统logo',
        enterLoginYseLink:"请输入登录成功后的链接",
        enterSystemSubsystemLink:'请输入对接系统的多个子系统链接',
        enterSystemBackLink:'请输入系统返回的链接',
        chooseForgetVerify:'请选择忘记密码的验证方式',
        atLeastOneOption:'请选择至少一个选项',
        customerExistsToReEnter:'客户端已经存在请重新输入',
        accountPasswordError:"账号或密码不正确请重新输入",
        inputAppID:"请输入应用ID",
        AppIDLengthLimit:"用户所属app长度在 6 到 9 个字符之间"
    },
    form:{
        userID:"用户ID",
        username:"用户名",
        cellphone:"手机号",
        IDcard:"身份证",
        status:"状态",
        updateTime:"更新时间",
        controls:'操作',
        cipher:"密码",
        resetpwd:"重置密码",
        userAddress:"用户地址",
        userApp:'用户所属app',
        userName:'用户名称',
        userpwd:'用户密码',
        userPhone:'用户手机号',
        userEmail:'用户邮箱',
        userSource:'用户来源',
        userRole:'用户角色',
        ordinaryUser:'普通用户',
        userVip:'普通管理员',
        userVips:'超级管理员',
        appID:'客户端ID',
        Customer:'客户名',
        secretKey:"密钥",
        loginTemplate:'登录模板',
        language:'语言',
        dockingSystemID:"对接系统的ID",
        systemName:"对接系统的名称",
        frontEndSystemTemplate:"对接系统的前端模板",
        systematicLogo:"对接系统的logo",
        loginJumpLink:"登录成功的跳转链接",
        subsystemOfSystemURL:"对接系统的多个子系统URL",
        backToSystemLink:"返回对接系统的链接",
        dockingSystemLanguage:"对接系统的国家语言",
        psdAuthentication:"忘记密码的验证方式",
        openEnrollmentOrNot:"是否开放注册",
        loginFailureSkipRegistration:"登录失败是否跳转注册",
        Role:'角色',
        applyID:"应用ID",

    }
}